import React, { useState } from "react";
import { Routes, Route, Navigate, NavLink } from "react-router-dom";
import OperationsJournal from "./OperationsJournal/OperationsJournal";
import RevenueRecognition from "./RevenueRecognition/RevenueRecognition";
import ExpenseRecognition from "./ExpenseRecognition/ExpenseRecognition";
import Allocation from "./Allocation/Allocation";
import { AccountingPlanningActionsContext } from "./AccountingPlanningActions";
import "./AccountingPlanningTabs.css";

const SECTIONS = [
  {
    id: "operations-journal",
    label: "Журнал операций",
    hint: "Все финансовые операции и результат их обработки",
  },
  {
    id: "revenue-recognition",
    label: "Признание выручки",
    hint: "Расчет и признание управленческой выручки по степени готовности проектов",
  },
  {
    id: "expense-recognition",
    label: "Признание расходов",
    hint: "Расчет и признание управленческих расходов по степени готовности проектов",
  },
  {
    id: "allocation",
    label: "Распределение",
    hint: "Распределение общих операций между проектами по выбранной базе",
  },
];

function AccountingPlanningTabs() {
  const [actionsContainer, setActionsContainer] = useState(null);

  return (
    <AccountingPlanningActionsContext.Provider value={actionsContainer}>
      <div className="apt">
        <div className="apt-bar">
          <nav className="apt-nav" aria-label="Разделы учета и планирования">
            {SECTIONS.map((section) => (
              <NavLink
                key={section.id}
                to={`/finances/accounting-planning/${section.id}`}
                title={section.hint}
                className={({ isActive }) =>
                  `apt-nav__item${isActive ? " is-active" : ""}`
                }
              >
                {section.label}
              </NavLink>
            ))}
          </nav>
          <div className="apt-bar__actions" ref={setActionsContainer} />
        </div>

        <div className="apt__content">
          <Routes>
            <Route path="operations-journal" element={<OperationsJournal />} />
            <Route path="revenue-recognition" element={<RevenueRecognition />} />
            <Route path="expense-recognition" element={<ExpenseRecognition />} />
            <Route path="allocation" element={<Allocation />} />
            <Route
              path="/"
              element={<Navigate to="operations-journal" replace />}
            />
          </Routes>
        </div>
      </div>
    </AccountingPlanningActionsContext.Provider>
  );
}

export default AccountingPlanningTabs;
